/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_ListExternalUniversitiesRow } from '../models/db_ListExternalUniversitiesRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExternalUniversities {
    /**
     * Get a list of external universities
     * @param countryId Country ID
     * @returns db_ListExternalUniversitiesRow OK
     * @throws ApiError
     */
    public static listExternalUniversities(
        countryId?: number,
    ): CancelablePromise<Array<db_ListExternalUniversitiesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/external-universities',
            query: {
                'country_id': countryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
